import { CLEAR } from 'redux/modules/content/actions/types';

export const clearLocations = () => ({
  type: CLEAR,
});
